﻿<div  id="category-product-type" [rdoFillRemainingHeight]>
  <div class="d-flex flex-row position-relative align-items-stretch scroll-container" [rdoCollapsedCards]="'product-type'">
    <rdo-collapsible [key]="'product-type'">
      <div class="rdo-col-card-fixed scroll"
        infinite-scroll
        [infiniteScrollThrottle]="500"
        (scrolled)="getPaginatedCards()"
        [scrollWindow]="false">
        <div class="rdo-card-list">
          @for (c of productCards; track c) {
            <rdo-nav-card
              [data]="c" [titleSelector]="'Description'"
              [selected]="isSelected(c)"
              [comparisonMode]="mode"
              (selectedChange)="selectProduct(c)"
              [rdo-scroll-into]="isSelected(c)">
            </rdo-nav-card>
          }
        </div>
      </div>
    </rdo-collapsible>
    <div class="rdo-col-card-offset container-fluid scroll-container collapsible-offset">
      <div class="row">
        <div class="col-12">
          <rdo-collapsible-button [key]="'product-type'" />
          <h3 class="heading product-types__title">
            @if (selectedProduct) {
              <div class="product-types__icon-container">
                <rdo-category-icon [category]="selectedProduct.CategoryIcon || selectedProduct.RouseCategory"></rdo-category-icon>
              </div>
              <rdo-product-type-title [title]="selectedProduct.Description" [isRentedAs]="params.useRentedAsProductType"></rdo-product-type-title>
            }
          </h3>
        </div>
      </div>
      <div class="row margin-bottom-xl">
        <div class="col-12">
          <ul class="nav nav-pills rdo-nav-pills">
            <li class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
              <a class="nav-link" [routerLink]="['./']" [ngClass]="params?.useRentedAsProductType && 'disabled'" [attr.data-text]="'main.core.common.dashboard' | translate">{{'main.core.common.dashboard' | translate}}</a>
            </li>
            <li class="nav-item" routerLinkActive="active">
              <a class="nav-link" [routerLink]="['sales-reps']" [attr.data-text]="'main.core.common.counts.sales_reps.plural' | translate">{{'main.core.common.counts.sales_reps.plural' | translate}}</a>
            </li>
            <li class="nav-item" routerLinkActive="active">
              <a class="nav-link" [routerLink]="['customers']" [attr.data-text]="'main.core.common.counts.customers.plural' | translate">{{'main.core.common.counts.customers.plural' | translate}}</a>
            </li>
            <li class="nav-item" routerLinkActive="active">
              <a class="nav-link" [routerLink]="['rate-types']" [attr.data-text]="'main.core.common.counts.rate_types.plural' | translate">{{'main.core.common.counts.rate_types.plural' | translate}}</a>
            </li>
            <li class="nav-item" routerLinkActive="active">
              <a class="nav-link" [routerLink]="['mom-change']" [ngClass]="params?.useRentedAsProductType && 'disabled'" [attr.data-text]="'main.tabs.equipment.product_types.mom_change' | translate">{{'main.tabs.equipment.product_types.mom_change' | translate}}</a>
            </li>
            <li class="nav-item" routerLinkActive="active">
              <a class="nav-link" [routerLink]="['yoy-change']" [ngClass]="params?.useRentedAsProductType && 'disabled'" [attr.data-text]="'main.tabs.equipment.product_types.yoy_change' | translate">{{'main.tabs.equipment.product_types.yoy_change' | translate}}</a>
            </li>
            @if (hasAssetGrid) {
              <li class="nav-item" routerLinkActive="active" id="product-type-rental-assets-list-item">
                <a class="nav-link" [routerLink]="['rental-assets']" [ngClass]="params?.useRentedAsProductType && 'disabled'" [attr.data-text]="'main.tabs.equipment.rental_assets.title' | translate">{{'main.tabs.equipment.rental_assets.title' | translate}}</a>
              </li>
            }
          </ul>
        </div>
      </div>
      <div class="row" id="category-product-type-content">
        <div class="scroll-container col-12">
          <div class="scroll">
            <router-outlet></router-outlet>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
